<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 38 35"
  >
    <path
      transform="matrix(.73625 .67671 -.5752 .81802 1.17 2.452)"
      stroke="#222"
      stroke-width="2.72"
      d="M0-1.36h47.306"
    />
    <path
      transform="matrix(-.73625 .67671 .5752 .81802 36.96 2.453)"
      stroke="#222"
      stroke-width="2.72"
      d="M0-1.36h47.306"
    />
  </svg>
</template>
